var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"group"},_vm._l((_vm.randomArr),function(item,index){return _c('div',{key:index,staticClass:"random-con"},[_c('div',{staticClass:"random-word",class:{
          'is-right': item.status == 'right',
          'is-normal': item.status == 'normal',
          'is-active-wrong': item.status == 'wrong',
        },style:({
          top: `${Math.random() * 160}px`,
        })},[_vm._v("\n        "+_vm._s(item.word)+"\n      ")])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }